export enum DictionaryType {
  Inventory = 'inventory',
  Equipment = 'equipment',
  Vehicle = 'vehicle',
  TaskTypes = 'task-types'
}
